import type { LayerProps } from "react-map-gl/maplibre";
import { LAYER_COLORS } from "../../../../../helpers/JobMap/JobMap.types";

export const POLYGON_FILL_LAYER_ID = "preview-polygon-fill";
export const POLYGON_LINE_LAYER_ID = "preview-polygon-line";
export const POINT_CIRCLE_LAYER_ID = "preview-point-circles";

export const previewPolygonFillLayer: LayerProps = {
	id: POLYGON_FILL_LAYER_ID,
	type: "fill",
	paint: {
		"fill-color": ["get", "color"],
		"fill-opacity": ["coalesce", ["get", "fillOpacity"], ["get", "opacity"], 0.4],
	},
};

export const previewPolygonLineLayer: LayerProps = {
	id: POLYGON_LINE_LAYER_ID,
	type: "line",
	paint: {
		"line-color": ["coalesce", ["get", "strokeColor"], ["get", "color"]],
		"line-width": ["coalesce", ["get", "strokeWeight"], 2],
		"line-opacity": ["coalesce", ["get", "strokeOpacity"], 1],
	},
};

export const previewPointCircleLayer: LayerProps = {
	id: POINT_CIRCLE_LAYER_ID,
	type: "circle",
	paint: {
		"circle-radius": 7,
		"circle-color": LAYER_COLORS.points,
		"circle-stroke-width": 1.5,
		"circle-stroke-color": "#666",
	},
};
